
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 2a7 7 0 00-7 7v6a7 7 0 1014 0V9a7 7 0 00-7-7zM7 9a5 5 0 014-4.9V10H7V9zm10 6a5 5 0 11-10 0v-3h10v3zm0-5h-4V4.1A5 5 0 0117 9v1z","fill":"#000"}})])
          )
        }
      }
    